import React, { useState } from "react";

const faqs = {
  en: [
    {
      question: "Does it cost to sign up?",
      answer:
        "No, it is completely free to sign up. There are no monthly payments required — it’s totally free.",
    },
    {
      question: "Do I have to buy loads to start?",
      answer:
        "No, you don’t have to buy anything. But like any business, you need some tools. Trying a few items to start with is a great step. Everything is amazing, so it's a win-win — glowing skin and sharing it with others!",
    },
    {
      question: "Do I have to send products to customers?",
      answer:
        "That’s up to you! You can do it yourself, or use our app to generate a customer link. They buy through it, and our company handles the shipping — totally hands-free if you prefer.",
    },
    {
      question: "How do I make money?",
      answer:
        "You earn commission on products you sell, plus sharing bonuses. There are also 2 more bonus types if you reach certain qualifications.",
    },
    {
      question: "Is it a pyramid scheme?",
      answer:
        "Nope! Pyramid schemes were made illegal in the 1980s. Our company is reputable and listed on the New York Stock Exchange. Anyone can move higher than the person who introduced them — it depends on your effort.",
    },
    {
      question: "Do I need lots of followers?",
      answer:
        "Not at all! You’d be surprised how many people you know. People love to buy from people they trust.",
    },
    {
      question: "Do I get support and help?",
      answer:
        "Absolutely! You’ll get full training and support from me and our community. You’re not alone.",
    },
  ],
  ar: [
    {
      question: "هل هناك رسوم للتسجيل؟",
      answer:
        "لا، التسجيل مجاني تمامًا. لا توجد أي رسوم شهرية — الأمر مجاني بالكامل.",
    },
    {
      question: "هل يجب أن أشتري الكثير للبدء؟",
      answer:
        "لا، ليس عليك شراء أي شيء. ولكن كما هو الحال مع أي مشروع، تحتاجين إلى أدوات. أنصحك بتجربة بعض المنتجات كبداية. كل شيء رائع، فالأمر رابح رابح — بشرة جميلة ومشاركة التجربة مع الآخرين!",
    },
    {
      question: "هل عليّ إرسال المنتجات للعملاء؟",
      answer:
        "هذا يعتمد عليك! يمكنك فعل ذلك بنفسك أو استخدام تطبيقنا لإنشاء رابط للعميل، حيث يشتري العميل من خلاله، وتتولى شركتنا الشحن — بدون تدخل منك إذا رغبتِ بذلك.",
    },
    {
      question: "كيف أكسب المال؟",
      answer:
        "تحصلين على عمولة على المنتجات التي تبيعينها، بالإضافة إلى مكافآت مشاركة. وهناك نوعان آخران من المكافآت إذا حققتِ شروطًا معينة.",
    },
    {
      question: "هل هو نظام هرمي؟",
      answer:
        "أبدًا! هذه الأنظمة أصبحت غير قانونية منذ الثمانينات. شركتنا موثوقة ومدرجة في بورصة نيويورك. يمكن لأي شخص أن يحقق نجاحًا يفوق من قام بدعوته، الأمر يعتمد على جهدك.",
    },
    {
      question: "هل أحتاج إلى عدد كبير من المتابعين؟",
      answer:
        "لا على الإطلاق! ستتفاجئين بعدد الأشخاص الذين تعرفينهم. الناس يشترون ممن يثقون بهم.",
    },
    {
      question: "هل سأحصل على دعم ومساعدة؟",
      answer:
        "بكل تأكيد! ستحصلين على تدريب كامل ودعم مني ومن مجموعتنا. لستِ وحدك.",
    },
  ],
};

const FAQSection = ({ language }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const currentFaqs = faqs[language || "en"];

  return (
    <div className="container my-5" dir={language === "ar" ? "rtl" : "ltr"}>
      <h2 className="text-center mb-4" style={{ fontFamily: "Libre Caslon Display, serif" }}>
        {language === "ar" ? "الأسئلة الشائعة" : "FAQ"}
      </h2>
      <div className="accordion">
        {currentFaqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return (
            <div key={index} className="mb-3 border rounded">
              <button
                className="btn w-100 text-start d-flex justify-content-between align-items-center p-3"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                style={{ backgroundColor: "#f9f9f9", fontWeight: "bold", fontSize: "17px" }}
              >
                <span>{faq.question}</span>
                <span style={{ fontSize: "22px" }}>{isOpen ? "−" : "+"}</span>
              </button>
              {isOpen && (
                <div className="mt-2 px-3 pb-3 text-muted" style={{ fontSize: "15px" }}>
                  {faq.answer}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FAQSection;
